const problems = [
  { icon: 'ri-emotion-happy-line', title: 'Понравился тренинг ≠ сотрудники работают лучше', desc: 'Положительные отзывы и улыбки на тренинге — это «вау-эффект», который рассеивается через 2-3 дня. Удовлетворённость участника не равна изменению его рабочих результатов.' },
  { icon: 'ri-refresh-line', title: 'Прошло обучение — ничего не изменилось', desc: 'Через месяц после тренинга сотрудники работают точно так же, как и до него. Знания не превратились в навыки, навыки — в привычки, привычки — в результаты.' },
  { icon: 'ri-bar-chart-grouped-line', title: 'HR не может показать ROI руководителю', desc: 'На вопрос собственника «Сколько мы заработали благодаря обучению?» у HR нет ответа. Без цифр обучение воспринимается как расход, а не инвестиция.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Руководители считают обучение расходом', desc: 'Когда нет измеримых результатов, обучение воспринимается как «развлечение за бюджет компании». Бюджет на обучение сокращают первым в кризис.' },
  { icon: 'ri-file-copy-2-line', title: 'Знания не внедряются в работу', desc: 'После тренинга сотрудники возвращаются в привычную среду: старые скрипты, старые привычки, прежнее давление текучки. Через 2 недели 80% знаний забыто.', },
  { icon: 'ri-error-warning-line', title: 'Нет системы оценки обучения', desc: 'Оценка заканчивается анкетой «Понравился ли вам тренинг?». Нет замеров до обучения, нет повторных замеров через месяц, нет анализа изменения KPI.' },
];

export default function WhyCompaniesDontUnderstand() {
  return (
    <section id="problems" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему большинство компаний не понимают, работает ли обучение
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Шесть системных проблем, из-за которых корпоративное обучение превращается в «чёрный ящик» — деньги потрачены, а результат неясен
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {problems.map((p, i) => (
            <div key={i} className="bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <i className={`${p.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3 leading-snug">{p.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}